<div class="superintendence-container">
  <div class="superintendence general-container">
    <div class="img-superintendence-logo"></div>
    <div (click)="navigate.goTo(superintendenceUrl)" class="text-banner" [ngClass]="font?.size">
      {{ superintendenceText | translate }}
      <span class="link-banner">{{ superintendenceLink | translate }}</span>.
    </div>
  </div>
</div>
